import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import { canonicalProductionURL } from './lib/authRedirect'
import { I18nProvider } from './lib/i18n'
import './styles.css'
import './responsive.css'

const canonicalURL = canonicalProductionURL(window.location.href)

if (canonicalURL) {
  window.location.replace(canonicalURL)
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <App />
            <Toaster position="top-right" richColors closeButton />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </StrictMode>,
  )
}
